import { ADDED, DELETED, LOADED, UPDATED } from "./actionType";
import { initialState } from "./initialState";

const nextBookId = (books) => {
  const maxId = books.reduce((maxId, book) => Math.max(book.id, maxId), -1);

  return maxId + 1;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDED:
      return [
        ...state,
        {
          id: nextBookId(state),
          ...action.payload,
        },
      ];

    case UPDATED:
      return state.map((book) =>
        book.id === action.payload.bookId
          ? { ...book, ...action.payload.updatedValue }
          : book
      );

    case DELETED:
      return state.filter((book) => book.id !== action.payload);

    case LOADED:
      return action.payload;

    default:
      return state;
  }
};

export default reducer;
